export default "__VITE_ASSET__CHh1vLD6__"